module.exports = __webpack_public_path__ + "static/media/post_img_1.2751be04.png";